export const META_PIXEL_ID = '1258591469407663'

const FBEVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

type FbqArguments = [string, ...unknown[]]

interface Fbq {
    (...args: FbqArguments): void
    callMethod?: (...args: FbqArguments) => void
    queue: FbqArguments[]
    push: Fbq
    loaded: boolean
    version: string
}

declare global {
    interface Window {
        fbq?: Fbq
        _fbq?: Fbq
    }
}

export const isMetaPixelEnabled = () => import.meta.env.VITE_ENVIRONMENT === 'production'

let initialized = false

const ensureStub = (): Fbq => {
    if (window.fbq) return window.fbq

    const fbq = function (this: unknown, ...args: FbqArguments) {
        if (fbq.callMethod) {
            fbq.callMethod(...args)
        } else {
            fbq.queue.push(args)
        }
    } as unknown as Fbq

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.push = fbq

    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    return fbq
}

const injectScript = () => {
    const existing = document.querySelector(`script[src="${FBEVENTS_SRC}"]`)
    if (existing) return

    const script = document.createElement('script')
    script.async = true
    script.src = FBEVENTS_SRC

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript?.parentNode?.insertBefore(script, firstScript)
}

export const initMetaPixel = () => {
    if (initialized || typeof window === 'undefined' || !isMetaPixelEnabled()) return
    initialized = true

    const fbq = ensureStub()
    injectScript()
    fbq('init', META_PIXEL_ID)
    fbq('track', 'PageView')
}

export const trackMetaPageView = () => {
    if (!initialized || typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'PageView')
}

export const trackMetaPurchase = (value: number, currency = 'HUF') => {
    if (!initialized || typeof window === 'undefined' || !window.fbq) return
    window.fbq('track', 'Purchase', { value, currency })
}
